import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getProductSupplierAll(params) {
	return client.get("api/supplier-product/data", {
		params: params,
	});
}

function exportProductSupplier(params) {
	return client.get("api/supplier-product/export", {
		params: params,
	});
}

function getProductWarehouseBySupplier(params) {
	return client.get("api/supplier-product/data_product_warehouse", {
		params: params,
	});
}

function getProductSupplierBySupplier(params) {
	return client.get("api/supplier-product/data_product_supplier", {
		params: params,
	});
}

function syncProduct(params) {
	return client.post("api/supplier-product/sync", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function asyncProduct(params) {
	return client.post("api/supplier-product/async", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getProductSupplierAll,
	exportProductSupplier,
	getProductWarehouseBySupplier,
	getProductSupplierBySupplier,
	syncProduct,
	asyncProduct
};